import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import CompanyInfo from "./CompanyInfo";
import CompanyInfoRejected from "./CompanyInfoRejected";
import {getStatus} from "../../../api/MoadianService";
import {error} from "jquery";
import {setStatus} from "../../redux/actions/TokneAction";

export default function CompletedCompanyInfo() {
    const tokenInfo = useSelector( state => state.Token);
    const [isRejected, setIsRejected] = useState(true)
    const [statusTrans, setStatusTrans] = useState("")
    const dispatch = useDispatch();

    useEffect( () => {

        getStatus(tokenInfo.transactionId).then(response => {
            setStatusTrans(response?.data?.transactionStatus)
            if(response?.data?.transactionStatus != 'PAID') {
                setIsRejected(false)
            }
            dispatch(setStatus({status : response.data.transactionStatus}))
        })
        .catch(error => console.warn(error.response.data.message))


    }, [])

    return(
        isRejected ? <CompanyInfo /> : <CompanyInfoRejected transactionStatus={statusTrans} />
    )
}